"use client";

import { Bot } from "lucide-react";
import { GradientIcon } from "../icons/gradient-icon";
import { Tooltip } from "../tooltip";

/**
 * Tooltip indicating that AI is used as a helper for creator profiles.
 * Encourages users to verify profiles themselves.
 */

const tooltipContent = `AI is used as a helper.
Check profiles to be sure.`;
export const AiTooltip = () => (
  <Tooltip className="max-w-20" content={tooltipContent}>
    <GradientIcon icon={Bot} size={16} />
  </Tooltip>
);
